import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { FlowParams } from '@frame/components/oe/generated/screen-types'
import { routes } from '@frame/routes'

export function useHandOffToOE() {
  const navigate = useNavigate()

  return useCallback(
    (flowParams: FlowParams) => {
      navigate(routes.oe, { state: { flowParams } })
    },
    [navigate]
  )
}
